import { render, staticRenderFns } from "./DetailsTypeCreneau.vue?vue&type=template&id=4501541b&"
import script from "./DetailsTypeCreneau.vue?vue&type=script&lang=ts&"
export * from "./DetailsTypeCreneau.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsTypeCreneau.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports